import React from "react";
import {connect} from 'react-redux'
import CreateEditClientForm from './CreateEditClientForm'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";


// @material-ui/core components
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
// import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from '@material-ui/core/LinearProgress';
import FormControl from "@material-ui/core/FormControl";
//clients
import {
  clientSave,
  clientsFetch,
  clientFetch,
  clientReassignIb,
  setClientViewFilter
} from 'actions/clients'

import {
  danger,
  success,
} from 'actions/notification'

import {
  profilesFetch
} from 'actions/profiles'
import {
  ibsFetchAll
} from 'actions/ibs'

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/form";

class Form extends React.Component {
  state={
    tab: 'create-edit',
    ibList: [],
      form:{
        clientId:0,
        address:'',
        email:'',
        name:'',
        externalId:'',
        ibid: '',
        profileid: '',
        phoneNumber:'',
        dbResource:'',
        registrationDate: '',
        registrationLink: '',
      }
  }

  submitReassignIb(e){
    if(e.preventDefault)
      e.preventDefault();
    this.props.clientReassignIb(this.state.form)
      .then(e=>{
        this.props.success(`Reassign IB for ${e.name} completed successfully`,4); 
        //this.props.setClientViewFilter({filterName: 'selectedIbId', value: this.state.form.ibid})
        //this.props.setClientViewFilter({filterName: 'selectedProfileId', value: this.state.form.profileid})
        this.props.fetchAll(this.state.form.ibid, this.state.form.profileid)
        this.props.history.goBack()
      })
      .catch(e=>{this.props.danger(e+'',4);})
  }

  componentWillMount(){
    if(this.props.ibs.length === 0) {
      this.props.ibsFetch().then(e=>{

          this.setState({
          ...this.state,
          ibList:e,
        })

        }); 
    }

    this.props.ibsFetch().then(e=>{

          this.setState({
          ...this.state,
          ibList:e,
        })

        });
    
    if(this.props.profiles) {
      if(this.props.profiles.length === 0) {
        this.props.profilesFetch()
      }
    } else {
      this.props.profilesFetch();
    }
    //Fetch information if is edit form
    this.fetchClient()
  }
  fetchClient(){
    const ibid = this.props.match.params.ibid
    const profileid = this.props.match.params.profileid
    if(this.props.match.params.id) {
      this.props.fetch(this.props.match.params.id, ibid, profileid)
        .then(e=>this.setState({
          ...this.state,
          form:{
            ...e,
            externalId: e.externalId || null,
            ibid,
            profileid
          }
      }));
    }
  }
  change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
  }
  
  renderCreateEditForm() {
    const editMode = this.props.match.params.id
    const clientid = this.props.match.params.id
    const ibid = this.props.match.params.ibid
    const profileid = this.props.match.params.profileid
    const ibList = this.state.ibList

    return (
      <CreateEditClientForm
        clientid={clientid}
        editMode={editMode}
        ibid={ibid}
        profileid={profileid}
        ibList={ibList}
        goBack={() => this.props.history.goBack()}
        clientData={this.state.form}
      />
    )
  }

  renderReassignIbForm() {
    const {classes, ibs, profiles}=this.props;
    const { ibList } = this.state;
    
    return (
      <form onSubmit={this.submitReassignIb.bind(this)}>
        <GridContainer justify="center">

          <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>

            {/*Profile select*/}
            <FormControl
              fullWidth
              className={classes.selectFormControl}
              style={{paddingTop:'27px', marginBottom: '17px'}}
            >
              <InputLabel
                htmlFor="profileid-reassign"
                className={classes.selectLabel}
              >
                Select Profile
              </InputLabel>     
              <Select
                value={Number(this.state.form.profileid) || ''}
                MenuProps={{ className: classes.selectMenu }}
                classes={{ select: classes.select }}
                inputProps={{
                  onChange:event => this.change(event, "profileid"),
                  id: "profileid-reassign"
                }
              }>
                {Object.values(profiles).map(profile => 
                  <MenuItem key={profile.profileId} value={profile.profileId}>{profile.name}</MenuItem>
                )}
              </Select>  
            </FormControl>

            {/*IB select*/}
            { ibList.length &&
            <FormControl
              fullWidth
              className={classes.selectFormControl}
              style={{paddingTop:'27px', marginBottom: '17px'}}
            >

              <InputLabel
                htmlFor="ibid-reassign"
                className={classes.selectLabel}
              >
                Select IB
              </InputLabel>
              <Select
                value={Number(this.state.form.ibid) || ''}
                MenuProps={{ className: classes.selectMenu }}
                classes={{ select: classes.select }}
                inputProps={{
                  onChange:event => this.change(event, "ibid"),
                  id: "ibid-reassign"
                }}
              >
                  {Object.values(ibList).map(ib => 
                    <MenuItem key={ib.ibId} value={ib.ibId}>{ib.firstName+' '+ib.lastName}</MenuItem>
                  )}
              </Select>  
            </FormControl>
            }
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={10}>
          <Button type="submit"  className={classes.submit} color="success">Submit</Button>
        </GridItem>
      </GridContainer>
    </form>
    )
  }
  changeTab(e, tab) {

    this.setState({
      ...this.state,
      tab
    },()=> this.fetchClient())
  }
  render() {
    const {isFetching}=this.props;
    const {tab,ibList} = this.state
    const editMode = this.props.match.params.id

    return (
          <GridContainer justify="center">
            <GridItem xs={12} sm={8}>
            <Card>
            <CardBody>
          
            {//Show progress onFetch
            (isFetching)         
            ?<LinearProgress/>
            : <div>
              
                {editMode && // show tabs only if edit
                  <Tabs
                    value={tab}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.changeTab.bind(this)}
                  >
                    <Tab value="create-edit" label={editMode ? 'Edit Client' : 'Create Client'} />
                    {editMode && <Tab value="reassign-ib" label="Reassign IB" />}
                  </Tabs>
                }


                {tab === 'create-edit' && <div>{this.renderCreateEditForm()}</div>}
                {ibList.length && tab === 'reassign-ib' && <div>{this.renderReassignIbForm()}</div>}

              </div>
              }
              </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
    );
  }
}
const mapStateToProps=(state,props)=>({
  isFetching:state.clients.isFetching,
  clients:state.clients,
  ibs: state.ibs,
  profiles: state.profiles.list
})
const mapDispatchToProps=(dispatch)=>({
  fetch:(clinetid, ibid, profileid)=>dispatch(clientFetch(clinetid, ibid, profileid)),
  fetchAll:(ibid, profileid) => dispatch(clientsFetch(ibid, profileid)),
  save:(data)=>dispatch(clientSave(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  success:(text,sec)=>dispatch(success(text,sec)),
  profilesFetch: () => dispatch(profilesFetch()),
  ibsFetch: () => dispatch(ibsFetchAll()),
  clientReassignIb: (data) => dispatch(clientReassignIb(data)),
  setClientViewFilter: (data) => dispatch(setClientViewFilter(data))
})
export default withStyles(styles)(connect(mapStateToProps,mapDispatchToProps)(Form));



// WEBPACK FOOTER //
// ./src/views/Clients/Form.jsx